import { Typography } from '@mui/material'

import { PanelBox } from '../default'
import { UserManagementTable } from '../tables'

/**
 * @description Renders a panel for managing access keys.
 *
 * @author Paulo Victor Borges
 * @returns {React.Component} The rendered UserManagementPanel component.
 */
const UserManagementPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Gerenciar Usuários Cadastrados
            </Typography>
            <UserManagementTable />
        </PanelBox>
    )
}

export default UserManagementPanel